import { action, observable } from 'mobx';
import { HttpClient } from 'Mri.Web.Common';
import { AccountStore } from '../Account/AccountStore';

interface ISetTwoFactorReturnModel {
    enabled: boolean;
}

export class ManageStore {
    public constructor(httpClient: HttpClient, accountStore: AccountStore) {
        this.accountStore = accountStore;
        this.httpClient = httpClient;
    }

    @action
    public async loadProvidersAsync() {
        this.providers = await this.httpClient.get<string[]>('/api/v1/manage/providers');
    }

    @action
    public async setTwoFactorAsync(model: Mri.Web.Portal.Controllers.Manage.SetTwoFactorModel) {
        const ret = await this.httpClient.post<ISetTwoFactorReturnModel>('/api/v1/manage/twofactor', model);
        if (this.accountStore.user && ret) this.accountStore.user.twoFactorEnabled = ret.enabled;
    }

    public async changePasswordAsync(model: Mri.Web.Portal.Controllers.Manage.ChangePasswordModel) {
        await this.httpClient.post('/api/v1/manage/changepassword', model);
    }

    public async changeEmailAsync(model: Mri.Web.Portal.Controllers.Manage.ChangeEmailModel) {
        await this.httpClient.post('/api/v1/manage/changeemail', model);
    }

    public async sendVerifyEmail() {
        await this.httpClient.post('/api/v1/manage/verifyemail');
    }

    public async changePhoneAsync(model: Mri.Web.Portal.Controllers.Manage.ChangePhoneModel) {
        await this.httpClient.post('/api/v1/manage/changephone', model);
    }

    @action
    public async verifyPhoneAsync(model: Mri.Web.Portal.Controllers.Manage.VerifyPhoneModel) {
        const user = await this.httpClient.post<Mri.Web.Portal.Controllers.Account.UserModel>(
            '/api/v1/manage/verifyphone',
            model
        );
        this.accountStore.userStorage.user = user;
    }

    @action
    public async changeSettingsAsync(model: Mri.Web.Portal.Controllers.Manage.ChangeUserSettingsModel) {
        const user = await this.httpClient.post<Mri.Web.Portal.Controllers.Account.UserModel>(
            '/api/v1/manage/settings',
            model
        );
        this.accountStore.userStorage.user = user;
    }

    public setMetaData(metaData: Mri.Web.Portal.Controllers.Account.MetaDataModel) {
        return this.changeSettingsAsync({
            preferredTheme: this.accountStore.user!.preferredTheme,
            viewedChangelog: this.accountStore.user!.viewedChangelog,
            metaData,
            statusVuNewTab: this.accountStore.user!.statusVuNewTab,
            fahrenheitPreferred: this.accountStore.user!.fahrenheitPreferred,
            multiSortPreferred: this.accountStore.user!.multiSortPreferred,
            subscribedToAlerts: this.accountStore.user!.subscribedToAlerts,
            preferredTimezone: this.accountStore.user!.preferredTimezone,
        });
    }

    @observable
    public providers?: string[];

    private readonly httpClient: HttpClient;
    private readonly accountStore: AccountStore;
}
